// @flow strict

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

let Root;
if (process.env.REACT_APP_MODE === "sevilla") {
  Root = require("~sevilla/Root").default;
} else {
  Root = require("~robin-hood/Root").default;
}

const RootElement = document.getElementById("root");

if (RootElement) {
  ReactDOM.render(
    <React.StrictMode>
      <Root />
    </React.StrictMode>,
    RootElement
  );
}
